<template>
	<BudgetChart
		:project-id="projectId"
		:retainer-period-id="retainerPeriodId"
	/>
</template>

<script setup lang="ts">
import { type RetainerPeriod, type Project } from '@/generated/graphql';
import { BudgetChart } from '@/features/Project';

defineProps<{
	projectId: Project['id'];
	retainerPeriodId?: RetainerPeriod['id'];
}>();
</script>
